import { render, staticRenderFns } from "./restaurant.vue?vue&type=template&id=10b31e9c"
import script from "./restaurant.vue?vue&type=script&lang=js"
export * from "./restaurant.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports